import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Card } from '@mui/material';
import axios from 'axios';
import '../App.css';
import Logo from '../uploads/Mayor-Logo.png'; // Ensure this path is correct
import API_ENDPOINTS from '../config/apiConfig';

function Login({ onLoginSuccess }) {
  const [email, setemail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.post('https://print.michaelmelham.com/api/auth/login', {
        email,
        password,
      });

      if (response.status === 200) {
        // Handle success, e.g., save token and notify parent component
        const token = response.data.token; // Ensure your API returns a token
        localStorage.setItem('authToken', token);
        onLoginSuccess();
      }
    } catch (err) {
      setError('Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="login-container">
      <Card className="login-card">
        <img src={Logo} alt="Company Logo" className="login-logo" width='100%' />
        <Typography variant="h5" className="login-header">
          Welcome to Mayor Michael Melham's Dashboard
        </Typography>
        {error && (
          <Typography variant="body2" color="error" style={{ marginBottom: '10px' }}>
            {error}
          </Typography>
        )}
        <TextField
          variant="outlined"
          label="email"
          fullWidth
          className="input-field"
          margin="normal"
          value={email}
          onChange={(e) => setemail(e.target.value)}
        />
        <TextField
          variant="outlined"
          label="Password"
          type="password"
          fullWidth
          className="input-field"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          variant="contained"
          className="button-primary"
          fullWidth
          style={{ marginTop: '20px' }}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? 'Logging in...' : 'Login'}
        </Button>
      </Card>
    </Box>
  );
}

export default Login;
